export enum EnumProducts {
  MULTIBENEFITS = "Multibenefícios",
  CORP_EXPENSES = "Despesas corporativas",
  AWARDS = "Premiações e/ou valores pontuais",
  CAJU_MAIS = "Caju mais",
  CAJU_CICLOS = "Caju ciclos",
  BENEFITS_WITH_WELLHUB = "Benefícios + Wellhub",
}
